import React, { useEffect } from 'react';

const VerifyEmail: React.FC = () => {
  useEffect(() => {
    // Hand off to backend with full query string (token, tier, etc.) preserved.
    const search = window.location.search; // includes leading '?' if present
    window.location.href = `https://quotebid-backend-production.up.railway.app/auth/verify-email${search}`;
  }, []);

  return (
    <div style={{ fontFamily: 'Arial, sans-serif', maxWidth: 600, margin: '50px auto', textAlign: 'center' }}>
      <p>Verifying your email...</p>
    </div>
  );
};

export default VerifyEmail;